<template>
  <div class="page">
    <MyTitle type="1" title="AI智能" class="title-scale"/>

    <div class="my-footer mt-80">
      <swiper :options="swiperOptions">
        <swiper-slide
          style="width: 365px"
          v-for="(item, index) in list"
          :key="'list' + index"
        >
          <div class="target flex flex-direction align-items">
            <div class="imgBox">
              <img
                class="img mt-20"
                :src="
                  require(`@/assets/images/digitalfactory/part5-${
                    index + 1
                  }.png`)
                "
                alt=""
              />
              <div class="numAnduuid flex flex-direction">
                <div class="flex align-items">
                  <div>
                    <img
                      class="icon-img"
                      src="@/assets/images/digitalfactory/VectorBlue.png"
                      alt=""
                      v-if="item.sort == 1"
                    />
                    <img
                      class="icon-img"
                      src="@/assets/images/digitalfactory/VectorOrange.png"
                      alt=""
                      v-if="item.sort == 2"
                    />
                  </div>
                  <span class="number">{{ item.number }}</span>
                  <span class="uuid">{{ item.uuid }}</span>
                </div>
                <div class="subLabel">
                  <span>{{ item.subLabel }}</span>
                </div>
              </div>
              <div></div>
            </div>
            <div class="label">
              {{ item.label }}
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import MyTitle from '@/views/exposition/components/title2'
export default {
  components: {
    MyTitle,
  },
  data() {
    return {
      list: [
        {
          label: "无人装卸",
          subLabel: "效率",
          number: "200",
          uuid: "%",
          sort:1
        },
        {
          label: "智能存储",
          subLabel: "库存利用率",
          number: "40",
          uuid: "%",
          sort:1
        },
        {
          label: "路径规划",
          subLabel: "效率",
          number: "80",
          uuid: "%",
          sort:1
        },
        {
          label: "自动化盘点",
          subLabel: "效率",
          number: "200",
          uuid: "%",
          sort:1
        },
        {
          label: "需求预测",
          subLabel: "风险",
          number: "30",
          uuid: "%",
          sort:2
        },
        {
          label: "危险识别",
          subLabel: "安全率",
          number: "80",
          uuid: "%",
          sort:1
        },
        {
          label: "智能巡检",
          subLabel: "效率",
          number: "70",
          uuid: "%",
          sort:1
        },
      ],

      swiperOptions: {
        loop: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        speed: 500,
        slidesPerView: 4.7,
        spaceBetween: 0,
        centeredSlides: true,
        watchSlidesProgress: true,
      },
    };
  },
  mounted() {
    // this.list[0].number = this.generateRandomNumber(0,3)
    // this.list[1].number = this.generateRandomNumber(0,3)
    // this.list[2].number = this.generateRandomNumber(3,5)
    // this.list[3].number = this.generateRandomNumber(5,10)
    // this.list[4].number = this.generateRandomNumber(3,5)
    // this.list[5].number = this.generateRandomNumber(20,25)
  },
  methods: {
    generateRandomNumber(min, max) {
      var randomNumber = Math.random() * (max - min) + min;
      return Math.floor(randomNumber);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./page.scss";
@import "@/assets/scss/comm.scss";
.page {
  height: 480px;
}
.my-footer {
  // width: 100%;
  height: 305px;
  .swiper-container {
    height: 100%;
    // background-color: pink;
    width: 1600px;
    // height: 215.37px;
  }

  .swiper-slide {
    .item-c-at {
      display: none;
    }
  }

  .swiper-slide-active {
    .item {
      .item-c {
        display: none;
      }

      .item-c-at {
        display: block;
      }

      .item-l {
        font-size: $FontSize36;
      }

      .item-v {
        height: 120px;
        margin-top: -80px;

        > span {
          color: #00fdf4;
          font-size: 96px;
        }
      }
    }
  }
}

.target {
  .label {
    font-size: $FontSize40;
  }
  .imgBox {
    position: relative;
    .numAnduuid {
      position: absolute;
      top: 20px;
      right: -100px;
      .icon-img {
        margin-left: -10px;
      }
      .uuid,.number {
        font-size: $FontSize64;
        color: $FontColor;
        @include ffamily-DS;
      }
      .uuid {
        font-size: $FontSize64;
      }
      .subLabel{
        color: #C6D1DB;
        font-size: $FontSize32;
      }
    }
  }
}
</style>